// admin/src/components/GroupSelector.js
import { useState, useEffect } from 'react';
import { useDataProvider, useStore, useRefresh } from 'react-admin';
import { Select, MenuItem, FormControl } from '@mui/material';

const GroupSelector = () => {
    const [groups, setGroups] = useState([]);
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    
    // Store selected group in React Admin's store
    const [activeGroupId, setActiveGroupId] = useStore('activeGroupId', null);
    
    useEffect(() => {
        // Fetch groups on mount
        dataProvider.getList('groups', {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'name', order: 'ASC' },
            filter: {}
        }).then(({ data }) => {
            setGroups([ {id: null, name: 'Select Group' }, ...data ] );

			if ( data.length ) {
				if ( ! ( activeGroupId && groups.find( g => ( g.id == activeGroupId ) ) ) ) {
					setActiveGroupId( data[0].id );
				}
			}

        });
    }, [dataProvider]);
    
    const handleChange = (event) => {
		if ( !event.target.value ) {
			return;
		}
        setActiveGroupId(event.target.value);
        // Refresh all lists to apply the new filter
        refresh();
    };
    
    return (
        groups.length === 1
        ? <span>{groups[0].name}</span>
        : <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
            <Select
                value={activeGroupId || ''}
                onChange={handleChange}
                
                sx={{ backgroundColor: 'white' }}
            >
                {groups.map(group => (
                    <MenuItem key={group.id || 'all'} value={group.id}>
                        {group.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default GroupSelector;